import script from "./PostManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PostManagement.vue?vue&type=script&setup=true&lang=js"

import "./PostManagement.vue?vue&type=style&index=0&id=f19716fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f19716fc"]])

export default __exports__